import {getData, getName} from 'country-list';
import {map, sortBy} from 'lodash';

const getCountryOptions = (): {id: string, name: string}[] => {
    const countries = sortBy(getData(), 'name');
    return map(countries, ({code, name}) => ({id: code, name}));
};

const getNameByCode = (code: string): string => getName(code);

export const countryUtils = {
    getCountryOptions,
    getNameByCode
};